import script from "./AppMenuTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMenuTooltip.vue?vue&type=script&setup=true&lang=js"

import "./AppMenuTooltip.vue?vue&type=style&index=0&id=60c1c756&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60c1c756"]])

export default __exports__